module.exports = __webpack_public_path__ + "static/media/chche.1a4ad535.mp3";